import { QueryType } from '../Default';
import { IQueryTypeFragments } from '../../QueryFragments';

const fragranceNotesFragment = `
    on ${QueryType.product} {
        fragrance_notes {
            key
            value
        }
    }
`;

export const fragranceNotesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: fragranceNotesFragment
    };
};
